var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "chargeItemInfo",
          attrs: { model: _vm.chargeItemInfo, rules: _vm.chargeItemRules }
        },
        [
          _c("div", { staticClass: "column-layout flex" }, [
            _c("div", { staticClass: "form-info" }, [
              _c("div", { staticClass: "form-row" }, [
                _c("div", { staticClass: "form-label" }, [
                  _c("label", { staticClass: "required" }, [_vm._v("服务类型")])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-value width-1-5x" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { prop: "servcTypeId" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: { disabled: _vm.initServcTypeId != null },
                            model: {
                              value: _vm.chargeItemInfo.servcTypeId,
                              callback: function($$v) {
                                _vm.$set(_vm.chargeItemInfo, "servcTypeId", $$v)
                              },
                              expression: "chargeItemInfo.servcTypeId"
                            }
                          },
                          _vm._l(_vm.servcTypeList, function(valueType) {
                            return _c("el-option", {
                              attrs: {
                                value: valueType.value,
                                label: valueType.text
                              }
                            })
                          })
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "content-caption dashed bg-white required" },
            [_c("span", [_vm._v("收费项")])]
          ),
          _vm._v(" "),
          _c("table", { staticClass: "custom-tbl" }, [
            _c("thead", { staticClass: "head" }, [
              _c("tr", { staticClass: "row" }, [
                _c("th", { staticStyle: { "text-align": "left" } }, [
                  _vm._v("名称")
                ]),
                _vm._v(" "),
                _c("th", { attrs: { width: "150" } }, [_vm._v("参考价格")]),
                _vm._v(" "),
                _c("th", { attrs: { width: "80" } }, [_vm._v("操作")])
              ])
            ]),
            _vm._v(" "),
            _c(
              "tbody",
              { staticClass: "body" },
              [
                _vm._l(_vm.subChargeItemList, function(item, index) {
                  return _vm.subChargeItemList != null &&
                    _vm.subChargeItemList.length > 0
                    ? _c("tr", { staticClass: "row" }, [
                        _c(
                          "td",
                          { staticStyle: { "text-align": "left" } },
                          [
                            _c("el-input", {
                              model: {
                                value: item.name,
                                callback: function($$v) {
                                  _vm.$set(item, "name", $$v)
                                },
                                expression: "item.name"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          [
                            _c("el-input", {
                              attrs: { type: "number" },
                              model: {
                                value: item.price,
                                callback: function($$v) {
                                  _vm.$set(item, "price", $$v)
                                },
                                expression: "item.price"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("td", [
                          _c(
                            "span",
                            {
                              staticClass: "swb-btn swb-btn-link",
                              on: {
                                click: function($event) {
                                  _vm.removeInfo(index)
                                }
                              }
                            },
                            [_vm._v("移除")]
                          )
                        ])
                      ])
                    : _vm._e()
                }),
                _vm._v(" "),
                _c("tr", { staticClass: "row" }, [
                  _c(
                    "td",
                    {
                      staticStyle: {
                        "text-align": "center",
                        "line-height": "40px"
                      },
                      attrs: { colspan: "3" }
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "swb-btn swb-btn-link",
                          on: {
                            click: function($event) {
                              _vm.addInfo()
                            }
                          }
                        },
                        [_vm._v("添加")]
                      )
                    ]
                  )
                ])
              ],
              2
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-41a02d5a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41a02d5a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/categ/ServcTypeChargeItemListSave.vue
// module id = 1901
// module chunks = 1